import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.sass';
import { If } from '../If/index.tsx';

const Spinner = ({ size, color, type }) => (
  <If
    condition={type === 'spoke'}
    ifRender={() => (
      <div
        className={styles.spinner}
        style={{
          height: `${size}px`,
          width: `${size}px`,
        }}
      >
        <div
          className={styles.spinnerSpoke}
          style={{ backgroundColor: color }}
        />
        <div
          className={styles.spinnerSpoke}
          style={{ backgroundColor: color }}
        />
        <div
          className={styles.spinnerSpoke}
          style={{ backgroundColor: color }}
        />
        <div
          className={styles.spinnerSpoke}
          style={{ backgroundColor: color }}
        />
        <div
          className={styles.spinnerSpoke}
          style={{ backgroundColor: color }}
        />
        <div
          className={styles.spinnerSpoke}
          style={{ backgroundColor: color }}
        />
        <div
          className={styles.spinnerSpoke}
          style={{ backgroundColor: color }}
        />
        <div
          className={styles.spinnerSpoke}
          style={{ backgroundColor: color }}
        />
        <div
          className={styles.spinnerSpoke}
          style={{ backgroundColor: color }}
        />
        <div
          className={styles.spinnerSpoke}
          style={{ backgroundColor: color }}
        />
        <div
          className={styles.spinnerSpoke}
          style={{ backgroundColor: color }}
        />
        <div
          className={styles.spinnerSpoke}
          style={{ backgroundColor: color }}
        />
      </div>
    )}
    elseRender={() => (
      <svg
        viewBox="0 0 38 38"
        xmlns="http://www.w3.org/2000/svg"
        stroke={color || '#8940fa'}
      >
        <g
          transform="translate(1 1)"
          strokeWidth="2"
          fill="none"
          fillRule="evenodd"
        >
          <circle
            cx="18"
            cy="18"
            r="18"
            stroke={color || '#c9cbcd'}
            opacity="0.5"
          />
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </svg>
    )}
  />
);

Spinner.propTypes = {
  size: PropTypes.number,
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.oneOf(['spoke', 'circle']),
};

Spinner.defaultProps = {
  size: 40,
  color: 'black',
  type: 'spoke',
};

export const CenteredSpinner = props => (
  <div className={styles.centered}>
    <Spinner {...props} />
  </div>
);

export { Spinner as default, Spinner };
